import { Component } from '@angular/core';

@Component({
  selector: 'app-eye-icon-svg',
  templateUrl: './eye-icon-svg.component.html',
  styleUrl: './eye-icon-svg.component.scss'
})
export class EyeIconSvgComponent {

}
